"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xsd = exports._ontologyResource = void 0;
/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
const models_1 = require("../models");
const Prefix_1 = require("../utils/Prefix");
var base = 'http://www.w3.org/2001/XMLSchema#';
exports._ontologyResource = models_1.NamedNode.getOrCreate(base);
Prefix_1.Prefix.add('xsd', base);
var string = models_1.NamedNode.getOrCreate(base + 'string');
var boolean = models_1.NamedNode.getOrCreate(base + 'boolean');
var date = models_1.NamedNode.getOrCreate(base + 'date');
var integer = models_1.NamedNode.getOrCreate(base + 'integer');
var time = models_1.NamedNode.getOrCreate(base + 'time');
var duration = models_1.NamedNode.getOrCreate(base + 'duration');
var decimal = models_1.NamedNode.getOrCreate(base + 'decimal');
var gYear = models_1.NamedNode.getOrCreate(base + 'gYear');
var Bytes = models_1.NamedNode.getOrCreate(base + 'Bytes');
var long = models_1.NamedNode.getOrCreate(base + 'long');
//not yet required by core so why define it?
//export var boolean:NamedNode = nodes.getOrCreate(base+"boolean");
exports.xsd = {
    _ontologyResource: exports._ontologyResource,
    string,
    boolean,
    date,
    integer,
    time,
    duration,
    decimal,
    gYear,
    Bytes,
    long,
};
//# sourceMappingURL=xsd.js.map